import config from 'config';
import { http_client } from './api';

const getList = async (latihanID, page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'latihan/' +
        latihanID +
        '/soal?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (latihanID, data, onProgress) => {
  return http_client.post(config.apiUrl + 'latihan/' + latihanID + '/soal/', data, null, onProgress).then((response) => {
    return response.data;
  });
};
const read = async (latihanID, id) => {
  return http_client.get(config.apiUrl + 'latihan/' + latihanID + '/soal/' + id).then((response) => {
    return response.data;
  });
};
const update = async (latihanID, id, data, onProgress) => {
  return http_client.post(config.apiUrl + 'latihan/' + latihanID + '/soal/' + id, data, null, onProgress).then((response) => {
    return response.data;
  });
};
const del = async (latihanID, id) => {
  return http_client.delete(config.apiUrl + 'latihan/' + latihanID + '/soal/' + id).then((response) => {
    return response.data;
  });
};

const getSession = async (latihanID, sessionID) => {
  return http_client.get(config.apiUrl + 'latihan/' + latihanID + '/' + sessionID).then((response) => {
    return response.data;
  });
};

const preview = async (latihanID) => {
  return http_client.get(config.apiUrl + 'latihan/' + latihanID + '/preview').then((response) => {
    return response.data;
  });
};

const storeScore = async (data) => {
  return http_client.post(config.apiUrl + 'latihan/soal/nilai', data).then((response) => {
    return response.data;
  });
};
const changeStatus = async (latihanID, soalID, data) => {
  return http_client.post(config.apiUrl + 'latihan/' + latihanID + '/soal/' + soalID + '/status', data).then((response) => {
    return response.data;
  });
};
const SoalService = {
  getList,
  create,
  read,
  update,
  del,
  getSession,
  preview,
  storeScore,
  changeStatus
};

export default SoalService;
